import { create } from "zustand";

export const useCampaignListingStore = create<ICampaignListingStore>((set, _get) => ({
  view: "card",
  setView: (newView: "list" | "card") => {
    set({ view: newView });
  },
}));

export interface ICampaignListingStore {
  view: "list" | "card";
  setView: (view: "list" | "card") => void;
}
